import type Listing from 'data/listing';

export function getBuyerRepresentationText(buyerInfo: Listing['buyerInfo'] | null): string | null {
  if (!buyerInfo) return null;

  const { agentFirstName, agentLastName, officeName } = buyerInfo;

  if (!agentFirstName && !agentLastName && !officeName) {
    return null;
  }

  let text = 'Buyer represented by ';
  if (agentFirstName && agentLastName) {
    text += `${agentFirstName} ${agentLastName}`;
  } else if (agentFirstName) {
    text += agentFirstName;
  } else if (agentLastName) {
    text += agentLastName;
  } else {
    text += 'an agent';
  }

  if (officeName) {
    text += ` of ${officeName}`;
  }

  return text;
}